// @ts-nocheck

import React, { useState, useEffect } from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'

import { colors } from '@lmc/common/constants'
import {
  FormInput,
  GlyphButton as OldGlyphButton,
} from '../../../LEGACY/elemental'
import { GlyphButton } from '../GlyphButton'

const handleSave = async (onSaveTitle, setIsEditable, newTitle) => {
  await onSaveTitle(newTitle)
  setIsEditable(false)
}

export default function EditableTitle(props) {
  const { title, titleStyles, onSaveTitle, containerStyles } = props
  const [isEditable, setIsEditable] = useState(false)
  const [newTitle, setNewTitle] = useState()

  useEffect(() => {
    setNewTitle(title)
  }, [title])

  return isEditable ? (
    <div style={{ ...styles.titleContainer, ...containerStyles }}>
      <FormInput
        size="default"
        type="text"
        value={newTitle}
        style={styles.editTitle}
        onChange={(e) => {
          setNewTitle(e.target.value)
        }}
      />
      <GlyphButton
        type="cancel"
        style={styles.cancelBtn}
        onClick={() => {
          setIsEditable(false)
          setNewTitle(title)
        }}
      />
      <GlyphButton
        text="Save"
        type="success"
        glyph="check"
        style={styles.saveBtn}
        disabled={newTitle === ''}
        onClick={() => {
          handleSave(onSaveTitle, setIsEditable, newTitle)
          setNewTitle(title)
        }}
      />
    </div>
  ) : (
    <div style={{ ...styles.titleContainer, ...containerStyles }}>
      <h2 style={titleStyles}>{title}</h2>
      <OldGlyphButton
        className={css(classes.titleEditBtn)}
        size="small"
        glyph="pencil"
        onClick={() => {
          setIsEditable(true)
        }}
      />
    </div>
  )
}

const classes = StyleSheet.create({
  titleEditBtn: {
    background: 'transparent !important',
    position: 'relative',
    top: -3,
    height: 30,
    color: `${colors.black} !important`,
    marginLeft: 6,
    transition: 'all .2s ease',
    ':hover': {
      background: `${colors.orange} !important`,
      color: `${colors.white} !important`,
    },
  },
})

const styles = {
  cancelBtn: {
    marginRight: 10,
    height: 32,
  },
  editTitle: {
    borderColor: null,
    height: 32,
    width: '100%',
    marginRight: 10,
  },
  saveBtn: {
    height: 32,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'baseline',
  },
}
